import { render, staticRenderFns } from "./corseProjectsManageModule.vue?vue&type=template&id=4389783f&scoped=true"
import script from "./corseProjectsManageModule.vue?vue&type=script&lang=js"
export * from "./corseProjectsManageModule.vue?vue&type=script&lang=js"
import style0 from "./corseProjectsManageModule.vue?vue&type=style&index=0&id=4389783f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4389783f",
  null
  
)

export default component.exports